import React from 'react';
import styled from 'styled-components';
import { Flex } from 'grid-styled';

const ContentWrapper = styled(Flex)`
  position: relative;
  width: 100%;
  min-height: 100%;
`;

class LargeContent extends React.Component {
  render() {
    return (
      <ContentWrapper width="{1/1}" flex="1 1 auto" is="div">
        {this.props.children}
      </ContentWrapper>
    );
  }
}

export default LargeContent;



// WEBPACK FOOTER //
// ./src/components/BasePage/LargeContent.js